import React, { useEffect, useState } from "react"
import { Container, Table, Label } from "reactstrap"
import { Row, Form } from "reactstrap"
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import ReactSelect from "react-select"

const ViewProjectDetails = ({ data }) => {

  const projectTypes = [
    { label: "Regular Project", value: "1" },
    { label: "Dedicated Resource", value: "2" },
    { label: "Maintenance Project", value: "3" },
  ]

  const ResourceType = [
    { label: "Fixed Rate", value: "1" },
    { label: "Project Hours", value: "2" },
    { label: "Dedicated Resource", value: "3" },
  ]

  console.log(ResourceType?.find((obj) => obj?.value == data?.billingtype)?.label)
  console.log(data)

  const selectedProjectType = projectTypes.find(type => type.value == data?.project_type)?.label
  return (
    <React.Fragment>

      <div className="px-0">
        <Container fluid>
          <Row className="" >
            <Form className="px-0" id="ViewProjectDetails">
              <Row className="">
                {/* Project Basic Details  */}
                <Row className="bg-white py-4 shadow mb-3 px-2">
                  <div className="col-sm-12 d-flex justify-content-between">
                    <div className="col-sm-6">
                      <h5 className="mb-3 text-dark">Project Basic Details</h5>
                    </div>
                  </div>
                  <div className="col-md-2 mt-2 mb-3 pe-1">
                    <label htmlFor="">
                      Project Belongs To <span className="text-danger">*</span>
                    </label>
                    <input
                      disabled
                      required
                      type="text"
                      placeholder="India"
                      className="form-control"
                    />
                  </div>

                  <div className="col-md-6 mt-2 mb-3 px-1">
                    <label htmlFor="">
                      Project Name <span className="text-danger">*</span>
                    </label>
                    <input
                      disabled
                      required
                      type="text"
                      placeholder="Project Name"
                      className="form-control "
                      value={data?.project_name || "-"}
                    />
                  </div>

                  <div className="col-md-3 mt-2 mb-3 px-1">
                    <label htmlFor="">
                      Project Type <span className="text-danger">*</span>
                    </label>
                    <input
                      disabled
                      className="form-control"
                      placeholder="Project Type"
                      value={selectedProjectType}
                    >
                    </input>
                  </div>

                  <div className="col-sm-12 mb-3 d-flex justify-content-start align-items-center gap-2">
                    <div className="col-md-2 mt-2 mb-3 mb-md-0">
                      <label htmlFor="">
                        {" "}
                        Source <span className="text-danger">*</span>
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Source"
                        value={"Introducer"}
                      >
                      </input>
                    </div>
                    <div className="col-sm-3 mt-2 mb-3 mb-md-0">
                      <label htmlFor="">
                        Resource Type <span className="text-danger">*</span>
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Resource Type"
                        value={ResourceType?.find((obj) => obj?.value == data?.billingtype)?.label}
                      >
                      </input>
                    </div>
                    <div className="col-sm-3 mb-3 mt-2 mb-md-0">
                      <label htmlFor="">
                        Select Customer
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Customer"
                        value={data?.customerDetails?.company || "-"}
                      >
                      </input>
                    </div>
                    <div className="col-sm-3 mt-2 mb-3 mb-md-0">
                      <label htmlFor="">
                        {" "}
                        Project Industry <span className="text-danger">*</span>
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Project Industry"
                        value={data?.industryDetails?.name || "-"}
                      >
                      </input>
                    </div>
                  </div>

                  <div className="col-12 disabled-editor">
                    <label htmlFor="">Description</label>
                    <div
                      className="form-control"
                      disabled
                      dangerouslySetInnerHTML={{ __html: data?.description }}
                    ></div>
                  </div>
                </Row>

              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewProjectDetails
